import { render, staticRenderFns } from "./SeletorDeCest.vue?vue&type=template&id=435c3ba0&"
import script from "./SeletorDeCest.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeCest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports